module.exports = "//d274d294w9cx2v.cloudfront.net/778ff5cb3483504b8488de21939f0854590ff11c/images/upload-your-own.png";